// extracted by mini-css-extract-plugin
export default {"container":"iP4K0","iconContainer":"zUf85","icon":"miyM2","logo":"TCsw0","label":"M5Zab"};